import { ref, watch } from "vue";
import { useRoute } from "vue-router";

/**
 * Quản lý danh sách route được keep-alive
 * @param {number} max Số route tối đa được cache
 */
export function useRouteCache(max = 5) {
    const route = useRoute();
    const cachedRoutes = ref([]);

    watch(
        () => route.name,
        (name) => {
            if (!name) return;

            const list = cachedRoutes.value;

            const index = list.indexOf(name);
            if (index !== -1) {
                // đã tồn tại thì đưa lên cuối
                list.splice(index, 1);
            }

            list.push(name);

            // giữ tối đa max route
            if (list.length > max) {
                list.shift();
            }
        },
        { immediate: true }
    );

    return {
        cachedRoutes,
    };
}
